import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText } from 'lucide-react';

export default function FloatingQuoteCTALarge() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 250);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (location.pathname.toLowerCase() === '/requestaquote' || location.pathname.toLowerCase() === '/request-a-quote') {
    return null;
  }

  return (
    <Link
      to="/request-a-quote"
      aria-label="Request a Quote"
      className={`fixed right-6 bottom-6 z-40 inline-flex items-center justify-center gap-3 rounded-full text-white font-bold shadow-lg transition-all duration-500 h-[60px] px-8 text-[17px] md:h-[64px] md:px-9 md:text-[18px] ${
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
      style={{
        background: '#2563eb',
        boxShadow: '0 10px 30px rgba(37,99,235,0.45), 0 4px 12px rgba(0,0,0,0.3)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#3b82f6';
        e.currentTarget.style.transform = 'translateY(-3px)';
        e.currentTarget.style.boxShadow = '0 16px 40px rgba(37,99,235,0.6), 0 6px 16px rgba(0,0,0,0.32)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#2563eb';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 10px 30px rgba(37,99,235,0.45), 0 4px 12px rgba(0,0,0,0.3)';
      }}
    >
      <FileText className="w-5 h-5 md:w-[22px] md:h-[22px]" strokeWidth={2} />
      <span className="tracking-wide whitespace-nowrap">Request a Quote</span>
    </Link>
  );
}
